import React from 'react'
import {
  StarVersion,
  StarVersionProps,
} from 'modules/versioning/components/StarVersion/StarVersion'

interface RevisionIconProps extends StarVersionProps {
  isActive?: boolean
  kind: string
  starOnHover: boolean
  isFirst?: boolean
}

export const RevisionIcon = ({
  kind,
  isActive,
  starOnHover,
  isFirst,
  ...starVersionProps
}: RevisionIconProps) => (
  <StarVersion
    disableAction={!starOnHover}
    isActive={isActive}
    isStarred={kind === 'DRAFT' ? false : true}
    isFirst={isFirst}
    {...starVersionProps}
  />
)
